import React, { ReactNode } from 'react';

import classNames from 'classnames';
import { Button } from 'antd';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import { Switch } from '../../../components';
import useOverflowDetector from '../../../components/overflow-detector/use-overflow-detector';

interface Props {
	ruleListItem: RuleListItem;
	translations: Translations;
	isButtonsDisabled?: boolean;
	onDelete: () => void;
	onToggle: () => void;
	onClick: () => void;
}

export interface Translations {
	merchantLevel: string;
	more: string;
}

export interface RuleListItem {
	id: string;
	ruleName: string;
	isMerchantLevel: boolean;
	teams?: string[];
	isEnabled: boolean;
	extra?: ReactNode;
}

const RulesListItem: React.FC<Props> = ({
	ruleListItem,
	onDelete,
	onToggle,
	onClick,
	translations,
	isButtonsDisabled
}) => {
	const { ref, overflowIndex } = useOverflowDetector([ruleListItem]);

	return (
		<div className={classNames('list-item', 'rules-list-item', { disabled: !ruleListItem.isEnabled })}>
			<div className="rule-name-column rule-name" onClick={onClick}>
				{' '}
				{ruleListItem.ruleName} {ruleListItem.extra}
			</div>
			<div className="rule-teams-column rule-teams" ref={ref}>
				{ruleListItem.isMerchantLevel ? (
					<div className="merchant-level">({translations.merchantLevel})</div>
				) : (
					<Teams overflowIndex={overflowIndex} ruleListItem={ruleListItem} translations={translations} />
				)}
			</div>
			<div className="toggle-column">
				<Switch checked={ruleListItem.isEnabled} onClick={onToggle} disabled={isButtonsDisabled} />
			</div>
			<div className="trash">
				<Button type="link" disabled={isButtonsDisabled} onClick={onDelete}>
					<BringgIcon iconName={BringgFontIcons.Trash} className="trash-icon" />
				</Button>
			</div>
		</div>
	);
};

const Teams = ({ ruleListItem, translations, overflowIndex }) => {
	let teams = ruleListItem.teams;
	let cutIndex = overflowIndex ? overflowIndex - 1 : ruleListItem.teams.length;
	if (teams.length > cutIndex) {
		teams = teams.slice(0, cutIndex);
	}
	let teamsComponents = teams.map(team => {
		return (
			<div className="team-ellipse" id={team} key={team}>
				{team}
			</div>
		);
	});
	const extraTeams = ruleListItem.teams.length - cutIndex;

	if (extraTeams > 0) {
		teamsComponents = [
			...teamsComponents,
			<div className="team-ellipse extra" key="extras">
				{`${extraTeams} ${translations.more}...`}
			</div>
		];
	}

	return teamsComponents;
};

export default RulesListItem;
